<!-- 详情的详情 -->
<template>
  <div class="xiangQing" v-loading="loading">
    <div>
      <el-button @click="goRouter">返回</el-button>
    </div>
    <div class="conent">
      <div id="online" v-if="this.$route.query.column != 'jd_count'"></div>
      <el-table v-else :data="tableData" style="width: 100%">
        <el-table-column prop="company_name" label="公司名"></el-table-column>
        <el-table-column
          prop="jd_position_name"
          label="招聘职位"
        ></el-table-column>
        <el-table-column
          prop="jd_place_name"
          label="职位地点"
        ></el-table-column>
        <el-table-column prop label="职位薪资">
          <template slot-scope="scope"
            >{{ scope.row.jd_salary_min }}-{{
              scope.row.jd_salary_max
            }}
            元</template
          >
        </el-table-column>
        <el-table-column prop="jd_place_name" label="招聘规模">
          <template slot-scope="scope"
            >{{ scope.row.jd_people_min }}-{{
              scope.row.jd_people_max
            }}
            人</template
          >
        </el-table-column>
        <el-table-column
          prop="jd_place_name"
          label="职位地点"
        ></el-table-column>
        <el-table-column
          prop="jd_send_count"
          label="投递人数"
        ></el-table-column>
        <el-table-column
          prop="jd_look_count"
          label="浏览数量"
        ></el-table-column>
        <el-table-column prop="update_time" label="更新时间"></el-table-column>
        <el-table-column prop="create_time" label="创建时间"></el-table-column>
      </el-table>
      <div class="page" v-if="this.$route.query.column == 'jd_count'">
        <el-pagination
          @current-change="handleCurrentChange"
          :total="total"
          :page-size="15"
          hide-on-single-page
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { require } from "@/utils/http_request.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      tableData: [],
      total: 0,
      loading: true,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleCurrentChange(page) {
      this.loading = true;
      this.requestTable(this.$route.query.id, page - 1);
    },
    goRouter() {
      this.$router.go(-1);
    },
    init() {
      if (this.$route.query.column == "is_online_count") {
        console.log("dadasdsa");
        this.requestLIne(this.$route.query.id, "online");
      }
      if (this.$route.query.column == "off_online_count") {
        console.log("dadasdsa");
        this.requestLIne(this.$route.query.id, "off_line");
      }
      if (this.$route.query.column == "radar_count") {
        console.log("dadasdsa");
        this.requestLIne(this.$route.query.id, "radar");
      }
      if (this.$route.query.column == "jd_count") {
        console.log("dadasdsa");
        this.requestTable(this.$route.query.id, 0);
      }
    },
    requestLIne(user_detail_id, show_data) {
      console.log(show_data);
      let obj = {
        user_detail_id: this.$route.query.id,
        show_data,
      };
      require("post", "/hr24_index_data/v1/client_line_chart/", obj).then(
        (res) => {
          if (!res.code) {
            var myChart = this.$echarts.init(document.getElementById("online"));

            if (show_data == "online") {
              this.showLine(
                myChart,
                res.data.data_list,
                res.data.time_list,
                "线上简历数量"
              );
            }
            if (show_data == "off_line") {
              this.showLine(
                myChart,
                res.data.data_list,
                res.data.time_list,
                "线下简历数量"
              );
            }
            if (show_data == "radar") {
              this.showLine(
                myChart,
                res.data.data_list,
                res.data.time_list,
                "雷达数量"
              );
            }
            this.loading = false;
          }
        }
      );
    },
    showLine(myChart, mon_data, day, text) {
      myChart.setOption({
        title: {
          text: text,
          textStyle: {
            fontSize: 14,
            fontWeight: "normal",
          },
        },
        legend: {
          data: ["数量"],
        },
        xAxis: {
          data: day,
        },
        yAxis: {},
        label: {},
        tooltip: {},
        series: [{ name: "数量", type: "line", data: mon_data }],
      });
    },
    requestTable(user_detail_id, page) {
      let obj = {
        page,
        user_detail_id,
      };
      require("post", "/hr24_index_data/v1/jd_list/", obj).then((res) => {
        if (!res.code) {
          console.log(res);
          this.tableData = res.data.jd_data;
          this.total = res.data.jd_count;
          this.loading = false;
        }
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.init();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */
.xiangQing {
  width: calc(100% - 230px);
  min-height: 80vh;
  background: #fff;
  margin-top: 68px;
  margin-left: 190px;
  padding: 20px;
}
.conent {
  margin-top: 20px;
}
#online {
  width: 95%;
  margin: auto;
  height: 600px;
}
.page {
  padding: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/index/xiangQing.vue